import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoginToken, reqData, reqFormData } from "../../../js/server";
import {
    cloneObj,
    fnNotAdmin,
    fnNotOfficers,
    wrapHTML,
} from "../../../js/util";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import SubMenu from "../../comm/SubMenu";
import SubBanner from "../../comm/SubBanner";
import Editor from "../../comm/Editor";
import {
    getServiceName,
    getSub01,
    getSub02,
    getSubHeader,
    escapeHTML,
} from "../../../js/util";

function AdminBoardEdit({ match, location, history }) {
    const dispatch = useDispatch();
    const usehistory = useHistory();
    const query = queryString.parse(location.search);
    const bserial = query.bserial;
    const kind = query.kind;
    const page = query.page;
    const keyword = query.keyword;
    const [userToken, setUserToken] = useState(null);
    const [username, setUsername] = useState("");
    const [boardKind, setBoardKind] = useState(null); //게시판종류
    const [subject, setSubject] = useState(""); //제목
    const [contents, setContents] = useState(""); //내용
    const [selectedFile1, setSelectedFile1] = useState(null);
    const [selectedFile, setSelectedFile] = useState([]);
    const [files, setFiles] = useState([]);

    const handleSubjectChange = (e) => {
        setSubject(e.target.value);
    };

    const handleFileChange1 = (e) => {
        setSelectedFile1(e.target.files[0]);
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files);
    };

    const fnSaveClick = () => {
        if (subject.length < 5) {
            alert("제목은 5자 이상 입력해 주세요.");
            document.querySelector("#subject").focus();
        } else if (contents.length < 10) {
            alert("내용은 10자 이상 입력해 주세요.");
        } else {
            if (window.confirm("저장하시겠습니까?")) {
                let formData = new FormData();
                if (selectedFile1) {
                    formData.append("file1", selectedFile1, selectedFile1.name);
                }
                if (selectedFile) {
                    Array.from(selectedFile).forEach((file) => {
                        formData.append("files", file, file.name);
                        console.log(file, file.name);
                    });
                }
                formData.append("servicename", `${getServiceName(boardKind)}Save`);
                formData.append("bserial", bserial);
                formData.append("userToken", userToken);
                formData.append("subject", subject);
                formData.append("contents", escapeHTML(contents));
                formData.append("username", username);

                dispatch({ type: "loadingChange", payload: true });
                reqFormData(formData)
                    .then((res) => {
                        alert("저장되었습니다.");
                        usehistory.push(
                            `/ABoardView?page=${page}&keyword=${encodeURI(
                                keyword
                            )}&kind=${kind}&bserial=${bserial}`
                        );
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        dispatch({ type: "loadingChange", payload: false });
                    });
            }
        }
    };

    const fetchData = () => {
        const userinfo = JSON.parse(localStorage.getItem("userinfo"));
        if (userinfo) {
            const _userToken = userinfo.userToken;
            const _userId = userinfo.userid;
            const _userType = userinfo.usertype;

            const jsonData = {
                servicename: `${getServiceName(kind)}View`,
                userToken: _userToken,
                bserial: bserial,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if ((Number(_userType) < 2 && boardKind !== "pds08") ||
                        (Number(_userType) < 1 && boardKind === "pds08") ||
                        _userId === res.data.jsonData.userid) {
                        setSubject(res.data.jsonData.subject);
                        setContents(wrapHTML(res.data.jsonData.contents));
                        setFiles(res.data.jsonFile);
                    } else {
                        //작성자나 관리자가 아닌 경우 아웃
                        alert("접근 권한이 없습니다.");
                        usehistory.goBack();
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const fnFileDelete = (idx) => {
        if (window.confirm("파일을 삭제 하시겠습니까?")) {
            const jsonData = {
                servicename: "FileDelete",
                userToken: userToken,
                fserial: files[idx].fserial,
            };
            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        let copiedObj = cloneObj(files);
                        copiedObj.splice(idx, 1);
                        setFiles(copiedObj);
                    } else {
                        console.log(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    useEffect(
        () => {
            dispatch({
                type: "pageChange",
                payload: { sub01: getSub01(kind), sub02: getSub02(kind) },
            });
            dispatch({ type: "loadingChange", payload: true });

            setTimeout(() => {
                //로그인 체크
                const userinfo = JSON.parse(localStorage.getItem("userinfo"));
                if (userinfo) {
                    setUserToken(userinfo.userToken);
                    setUsername(userinfo.username);
                    setBoardKind(kind);

                    //로그인 체크 후 Usertype 검사
                    LoginToken(userinfo.userToken)
                        .then((res) => {
                            if (res.data.result === "OK") {
                                if (
                                    Number(res.data.jsonData.usertype) > 1 &&
                                    kind !== "free" &&
                                    kind !== "joboffer" &&
                                    kind !== "jobsearch"
                                ) {
                                    fnNotAdmin();
                                } else if (
                                    //임원 자료실인 경우
                                    boardKind === "pds05" &&
                                    Number(res.data.jsonData.usertype) > 2
                                ) {
                                    fnNotOfficers();
                                } else if (
                                    //조합 자료실은 조합직원 이상만 열람 가능
                                    boardKind === "pds08" &&
                                    Number(res.data.jsonData.usertype) > 1
                                ) {
                                    fnNotOfficers();
                                } else {
                                    fetchData();
                                }
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            localStorage.removeItem("userinfo");

                            fnNotAdmin();
                        })
                        .finally(() => {
                            dispatch({ type: "loadingChange", payload: false });
                        });
                } else {
                    fnNotAdmin();
                }
            }, 500);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <>
            <SubBanner id={kind} />

            <section className="adminboard section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="row">{getSubHeader(boardKind)}</div>

                            <div className="row pb-10 pt-20">
                                <div className="col-12">
                                    <button
                                        className="btn btn-light btn-custom-sm"
                                        type="button"
                                        onClick={() => usehistory.goBack()}
                                    >
                                        <i className="icofont-arrow-left"></i>&nbsp;뒤로
                                    </button>
                                </div>
                            </div>

                            <div className="container pb-20">
                                <div className="row round-box">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className="form-control-label">제목</label>
                                                    <input
                                                        id="subject"
                                                        name="subject"
                                                        type="text"
                                                        className="form-control"
                                                        maxLength="50"
                                                        value={subject || ""}
                                                        onChange={handleSubjectChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {kind === "gallery" ? (
                                            <div className="row pb-20">
                                                <div className="col-12">
                                                    <div className="custom-file">
                                                        <input
                                                            id="file1"
                                                            type="file"
                                                            className="custom-file-input"
                                                            accept="image/*"
                                                            onChange={handleFileChange1}
                                                        />
                                                        <label
                                                            className="custom-file-label"
                                                            for="customFile"
                                                        >
                                                            {selectedFile1
                                                                ? selectedFile1.name
                                                                : "썸네일 이미지 (변경시 입력)"}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        <div className="row">
                                            <div className="col-12">
                                                <Editor
                                                    contents={contents || ""}
                                                    setContents={setContents}
                                                    boardKind={kind}
                                                    placeholder="내용을 입력해 주세요."
                                                ></Editor>
                                            </div>
                                        </div>

                                        {kind !== "gallery" ? (
                                            <>
                                                <div className="row pt-10">
                                                    <div className="col-12">
                                                        <input
                                                            id="file"
                                                            type="file"
                                                            accept="audio/*, video/*, image/*, application/pdf, application/msword, application/vnd.ms-excel, .docx, .hwp, .pptx, .zip, .alz, .txt"
                                                            multiple={true}
                                                            onChange={handleFileChange}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row pt-10 pb-30">
                                                    {files.map((file, i) => {
                                                        return (
                                                            <div className="col-12" key={i}>
                                                                등록 된 파일 : {files[i].file_name}&nbsp;
                                                                <i
                                                                    className="icofont-ui-delete"
                                                                    onClick={() => {
                                                                        fnFileDelete(i);
                                                                    }}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        ) : null}

                                        <div className="row pt-20">
                                            <div className="col-12 text-center">
                                                <span
                                                    className="btn btn-main btn-icon btn-round-full"
                                                    onClick={fnSaveClick}
                                                >
                                                    저장
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {kind === "info" || kind === "docu" || kind === "pds" ? (
                            <SubMenu id="docu" />
                        ) : (
                            <SubMenu id="community" />
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}

export default AdminBoardEdit;
